import { useState } from 'react';

import type { Id } from '../../api/types';
import { Toast } from '../../components';
import { useQltClassNoteStore } from '../../stores/qlt';
import { ClassLogbookEditor } from './ClassLogbookEditor';
import { classMarkLabel } from './classNoteFields';
import '../../styles/class-management.css';

export interface ClassLogbookCardProps {
  periodLabel: string;
  subjectTitle?: string;
  lessonTitle?: string;
  classNoteId?: Id;
}

function linkedLessonName(value: unknown): string {
  if (!value || typeof value !== 'object') return '';
  return String((value as { name?: string }).name || '');
}

export function ClassLogbookCard({ periodLabel, subjectTitle, lessonTitle, classNoteId }: ClassLogbookCardProps) {
  const note = useQltClassNoteStore((state) => state.currentNote);
  const linkedLesson = useQltClassNoteStore((state) => state.currentLesson);
  const [editorOpen, setEditorOpen] = useState(false);
  const [savedToast, setSavedToast] = useState(false);
  // the upsert blanks note.lesson on a fresh record, so the board's own lesson title is the backstop
  const lessonName = linkedLessonName(linkedLesson?.topicLesson) || note?.lesson || lessonTitle || '';
  const mark = classMarkLabel(note?.data);
  const comment = (note?.data?.classComment || '').trim();

  return (
    <>
      <section className="cm-card">
        <div className="cm-card__head"><h3 className="cm-card__title">Nội dung buổi học</h3></div>
        <p className="cm-card__lead">{lessonName || 'Chưa có'}</p>
      </section>
      <section className="cm-card">
        <div className="cm-card__head">
          <h3 className="cm-card__title">Đánh giá tiết học</h3>
          <button type="button" className="cm-card__more" disabled={!classNoteId || !note} onClick={() => setEditorOpen(true)}>Thêm</button>
        </div>
        {!classNoteId ? <p className="cm-card__empty">Tiết học chưa được ghi vào sổ đầu bài.</p> : (
          <dl className="cm-card__rows">
            <div className="cm-card__row"><dt>Đánh giá lớp</dt><dd>{mark || 'Chưa có'}</dd></div>
            <div className="cm-card__row"><dt>Nhận xét</dt><dd>{comment || 'Chưa có'}</dd></div>
          </dl>
        )}
      </section>
      <ClassLogbookEditor open={editorOpen} periodLabel={periodLabel} subjectTitle={subjectTitle} lessonName={lessonName} onClose={() => setEditorOpen(false)} onSaved={() => setSavedToast(true)} />
      <Toast open={savedToast} message="Đã lưu đánh giá tiết học" onClose={() => setSavedToast(false)} />
    </>
  );
}
